import { Observable } from "rxjs";
import {
  GlobalSearchRecord,
  GlobalSearchResponse,
} from "../models/global-search.model";

export abstract class GlobalSearchRepository {
  abstract search(query: string): Observable<GlobalSearchResponse>;
  abstract searchByType(
    type: string,
    query: string,
  ): Observable<GlobalSearchRecord[]>;
}
